import React, { useEffect } from 'react';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { IntlShape, injectIntl } from 'react-intl';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import TablePagination from '@material-ui/core/TablePagination';
import { resetSearchClaimsStore } from 'containers/IdentificationPage/actions';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import IconButton from '@material-ui/core/IconButton';
import { get, isEmpty } from 'lodash';

import { translate } from 'containers/services/translate';
import messages from 'containers/ManagerOpenedClaimsPage/messages';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { SagisLawyerAssignedClaims } from 'containers/ManagerOpenedClaimsPage/typings';
import {
  requestManagerOpenedClaims,
  requestSagisLawyerAssignedClaims,
  resetManagerOpenedClaims,
} from 'containers/ManagerOpenedClaimsPage/actions';
import {
  makeSelectCountOpenedClaims,
  makeSelectOpenedClaims,
  makeSelectSagisLawyerAssignedClaims,
} from 'containers/ManagerOpenedClaimsPage/selectors';
import { CLAIM_STATUS } from 'containers/data-structure';
import { ROW_PER_PAGE } from 'constants/global';
import { makeSelectListingsByField } from 'containers/AppContainer/selectors';
import { formatClaim, isManager } from 'containers/AppContainer/utils';
import {
  ClaimByStatus,
  Listings,
  SagisConfig,
} from 'containers/AppContainer/typings';
import { hasFeature } from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import {
  requestAssigment,
  resetStoreClaim,
} from 'containers/RecapManagerPage/actions';
import { LISTINGS } from 'containers/data-structure';
import AssignmentDialog from 'containers/RecapManagerPage/AssignmentDialog';
import {
  makeSelectCorporealLawyers,
  makeSelecOpenedClaim,
} from 'containers/RecapManagerPage/selectors';
import { requestCorporealLawyers } from 'containers/RecapManagerPage/actions';
import { KeycloakUser } from 'containers/RecapManagerPage/typings';
import { Claim } from 'containers/PreOpeningPage/typings';
import {
  shouldDisplayAssignmentDialogButton,
  getClaimNumbers,
} from 'containers/ManagerOpenedClaimsPage/utils';
import { SEARCH_TYPE } from 'containers/ValidatedClaimsPage/constants';
import { requestSearch } from 'containers/ValidatedClaimsPage/actions';
import CardTitle from 'containers/common/Card/CardTitle';
import NewSearchBar, { SearchQuery } from 'components/NewSearchBar';
import { SEARCH_QUERY_INIT_VALUES } from 'components/NewSearchBar/constants';

const Container = styled.div`
  margin-top: 50px;
  padding-top: 0px;
  .title {
    text-align: left;
    font-family: Roboto;
    font-weight: Bold;
    font-size: 18px;
    letter-spacing: 0;
    color: #384264;
    opacity: 1;
    padding: 10px;
  }
  .headerTitle {
    text-align: left;
    font-size: 11px;
    letter-spacing: 0;
    color: #000000de;
    text-transform: none;
    opacity: 1;
    font-family: Roboto;
    padding-bottom: 0px;
    font-weight: Bold;
  }
  .row {
    border-radius: 4px;
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    font-size: 11px;
    color: #2b2727;
  }
  .claims {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
`;

export interface ManagerOpenedClaimsPageProps {
  intl: IntlShape;
  openedClaims: ClaimByStatus[];
  requestManagerOpenedClaims: Function;
  countClaims: number;
  cities: SagisConfig[];
  listings: Listings;
  requestAssigment: Function;
  requestCorporealLawyers: Function;
  corporealLawyers: KeycloakUser[];
  requestSagisLawyerAssignedClaims: Function;
  sagisLawyerAssignedClaims: SagisLawyerAssignedClaims[];
  requestSearch: Function;
  openedClaim: any;
  location: { pathname: string };
  resetManagerOpenedClaims: Function;
  resetSearchClaimsStore: Function;
  resetStoreClaim: Function;
}

export const ManagerOpenedClaimsPage: React.FC<ManagerOpenedClaimsPageProps> = (
  props,
): JSX.Element => {
  const [page, setPage] = React.useState(0);
  const [pageSize, setRowsPerPage] = React.useState(25);
  const [
    isAssignToACourtManagerDialogOpen,
    setAssignToACourtManagerDialogOpen,
  ] = React.useState<boolean>(false);
  const [claimToAssign, setClaimToAssign] = React.useState({});

  const [searchQuery, setSearchQuery] = React.useState<SearchQuery>(
    SEARCH_QUERY_INIT_VALUES,
  );
  useEffect(() => {
    props.resetSearchClaimsStore();
    props.resetStoreClaim();
    props.requestManagerOpenedClaims(CLAIM_STATUS.VALIDATED, page, pageSize);
    return () => props.resetManagerOpenedClaims();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      !isEmpty(props.openedClaims) &&
      isEmpty(props.sagisLawyerAssignedClaims)
    ) {
      props.requestSagisLawyerAssignedClaims(
        getClaimNumbers(props.openedClaims),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.openedClaims]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    props.requestManagerOpenedClaims(CLAIM_STATUS.VALIDATED, newPage, pageSize);
    props.requestSagisLawyerAssignedClaims(getClaimNumbers(props.openedClaims));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const size = parseInt(event.target.value, 10);
    setRowsPerPage(size);
    props.requestManagerOpenedClaims(CLAIM_STATUS.VALIDATED, page, size);
    props.requestSagisLawyerAssignedClaims(getClaimNumbers(props.openedClaims));
  };

  const formattedOpenedClaims = formatClaim(
    props.openedClaims,
    props.cities as SagisConfig[],
    props.sagisLawyerAssignedClaims,
  );

  const handleOpenCourtManagerAssignmentPopin = (
    claim: ClaimByStatus,
  ) => (event: { stopPropagation: Function }) => {
    setClaimToAssign({ ...claim });
    event.stopPropagation();
    setAssignToACourtManagerDialogOpen(true);
  };

  const closeAndRefresh = () => {
    setAssignToACourtManagerDialogOpen(false);
    props.requestManagerOpenedClaims(CLAIM_STATUS.VALIDATED, page, pageSize);
  };

  const handlerSearch = () => {
    const query = {
      searchCriteria: {
        ...searchQuery,
        status: CLAIM_STATUS.VALIDATED,
      },
      searchType: SEARCH_TYPE.CLAIM,
    };
    props.requestSearch(query);
  };

  const handlerRefresh = () => {
    setSearchQuery(SEARCH_QUERY_INIT_VALUES);
    props.requestManagerOpenedClaims(CLAIM_STATUS.VALIDATED, page, pageSize);
  };

  return (
    <Container>
      <Card>
        <CardContent>
          <div className="header">
            <CardTitle
              count={props.countClaims}
              message={translate({ ...messages.title }, props)}
            />
            {hasFeature(FEATURES.SEARCH_BAR) && (
              <NewSearchBar
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                handlerSearch={handlerSearch}
                handlerRefresh={handlerRefresh}
                isHomePage={false}
                showAll={isManager(props)}
              />
            )}
          </div>
          <div>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.claimNumber }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.registrationNumber }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.openingDate }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.lossDate }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.claimPlace }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.lossHour }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.numberOfVictim }, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate({ ...messages.lawyer }, props)}
                  </TableCell>
                  <TableCell colSpan={9}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {formattedOpenedClaims.map(row => (
                  <TableRow
                    key={row.id}
                    onClick={pushTo(`${PAGES.MANAGER_RECAP_PAGE}/${row.id}`)}
                  >
                    <TableCell align="left" className="row">
                      {row.claimNumber}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {row.registrationNumber}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {moment(row.createdAt).format('YYYY-MM-DD')}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {moment(row.lossDate).format('YYYY-MM-DD')}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {row.lossLocationLabel}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {row.lossHour}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {row.victims.length}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {row.createdBy}
                    </TableCell>
                    {hasFeature(FEATURES.COURT_MANAGER_ASSIGNMENT) &&
                    shouldDisplayAssignmentDialogButton(
                      row as ClaimByStatus,
                    ) ? (
                      <TableCell
                        className="add-button"
                        onClick={handleOpenCourtManagerAssignmentPopin(
                          row as ClaimByStatus,
                        )}
                      >
                        <IconButton aria-label="delete">
                          <AddCircleOutlineIcon />
                        </IconButton>
                      </TableCell>
                    ) : (
                      <TableCell />
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={ROW_PER_PAGE}
              component="div"
              count={props.countClaims}
              rowsPerPage={pageSize}
              page={page}
              labelRowsPerPage={translate({ ...messages.linesPerPage }, props)}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </div>
        </CardContent>
      </Card>
      <AssignmentDialog
        open={isAssignToACourtManagerDialogOpen}
        onClose={setAssignToACourtManagerDialogOpen}
        subServices={get(props.listings, LISTINGS.SUB_SERVICES, [])}
        zonesCodes={get(props.listings, LISTINGS.ZONE_CODES, [])}
        services={get(props.listings, LISTINGS.SERVICES, [])}
        stackholders={get(props.listings, LISTINGS.STACKHOLDERS, [])}
        stackholderTypes={get(props.listings, LISTINGS.STACKHOLDER_TYPE, [])}
        requestAssigment={props.requestAssigment}
        claim={claimToAssign as Claim}
        requestCorporealLawyers={props.requestCorporealLawyers}
        corporealLawyers={props.corporealLawyers}
        closeAndRefresh={closeAndRefresh}
        shouldAssignOnSagis
        isManagerOpenedClaimsPage
        listings={props.listings}
        claimNumber={get(props.openedClaim, 'data.claimNumber')}
        requestManagerOpenedClaims={props.requestManagerOpenedClaims}
        isClaim
      />
    </Container>
  );
};

const mapDispatchToProps = {
  requestManagerOpenedClaims,
  requestAssigment,
  requestCorporealLawyers,
  requestSagisLawyerAssignedClaims,
  requestSearch,
  resetManagerOpenedClaims,
  resetSearchClaimsStore,
  resetStoreClaim,
};

const mapStateToProps = createStructuredSelector({
  openedClaims: makeSelectOpenedClaims(),
  countClaims: makeSelectCountOpenedClaims(),
  cities: makeSelectListingsByField(LISTINGS.CITIES),
  listings: makeSelectListings(),
  corporealLawyers: makeSelectCorporealLawyers(),
  sagisLawyerAssignedClaims: makeSelectSagisLawyerAssignedClaims(),
  openedClaim: makeSelecOpenedClaim(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ManagerOpenedClaimsPage));
